import { Record } from 'immutable';

const EventMenuSearchFilterPaymentStatusRecord = Record({
  inProcess: true,
  unpaid: true,
  paid: true,
  cancelled: false,
});

export class EventMenuSearchFilterPaymentStatus extends EventMenuSearchFilterPaymentStatusRecord {
  inProcess: boolean;
  unpaid: boolean;
  paid: boolean;
  cancelled: boolean;
}

const EventMenuSearchFilterEventPaymentStatusRecord = Record({
  paid: false,
  partial: false,
  unpaid: false
});

export class EventMenuSearchFilterEventPaymentStatus extends EventMenuSearchFilterEventPaymentStatusRecord {
  paid: boolean;
  partial: boolean;
  unpaid: boolean;
}

const EventMenuSearchFilterRecord = Record({
  commissionId: null,
  fundingReferenceId: null,
  paymentReferenceId: null,
  startDate: null,
  endDate: null,
  guestName: null,
  eventStatusCompleted: false,
  eventStatusMissingAgency: false,
  eventStatusArchived: false,
  paymentStatus: {
    inProcess: false,
    unpaid: false,
    paid: false,
    cancelled: false,
  },
  eventPaymentStatus: {
    paid: false,
    partial: false,
    unpaid: false
  },
  includeArchivedEvents: false,
  includeDeletedEvents: false,
  hasPrepayment: false,
  includeCommRetentionEvents: false,
  dashboardPaymentStatus: null,
  dashboardMissingContactEmail: null
});

export class EventMenuSearchFilter extends EventMenuSearchFilterRecord {
  commissionId: string;
  fundingReferenceId: string;
  paymentReferenceId: string;
  hasPrepayment: boolean;
  startDate: string;
  endDate: string;
  guestName: string;
  eventStatusMissingAgency: boolean;
  eventStatusCompleted: boolean;
  eventStatusArchived: boolean;
  includeArchivedEvents: boolean;
  includeDeletedEvents: boolean;
  paymentStatus: EventMenuSearchFilterPaymentStatus;
  eventPaymentStatus: EventMenuSearchFilterEventPaymentStatus;
  includeCommRetentionEvents: boolean;
  dashboardPaymentStatus: string;
  dashboardMissingContactEmail: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-menu-search-filter.ts